
            const data = {"name":"menu2","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M2 8h12M2 4h12M2 12h12\" _stroke=\"#7D92A7\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#7D92A7"}],"stopColors":[]}}
        
                    module.exports = data
                    